// extracted by mini-css-extract-plugin
export default {"settingsWallaperCont":"settings-wallaper-item_settingsWallaperCont__hbrvp"};